import { useContext } from 'react';
import { LinkUserMaterial } from '../../../../../api/user-material';
import parseYoutubeURL from '../../../../../utils/parseYoutubeURL';
import { UserMaterialDialogHeaderTags } from '../../../components/UserMaterialDialogHeaderTags';
import EmbeddableMediaModal from '../../components/modals/EmbeddableMediaModal';
import TableOfContentsContext from '../../_contexts/TableOfContentsContext';
import IdentityContext from '../../../../../contexts/IdentityContext';

export default function useLinkUserMaterial() {
  const { nodes } = useContext(TableOfContentsContext);
  const { identity } = useContext(IdentityContext);

  function openLinkUserMaterial(material: LinkUserMaterial) {
    const parsedYoutubeURL = parseYoutubeURL(material.href);

    if (parsedYoutubeURL) {
      return (
        <EmbeddableMediaModal
          url={parsedYoutubeURL}
          name={material.name}
          id="embeddable-media-modal"
          headerProps={{
            title: material.name,
            titleTooltip: material.name,
            tags: (
              <UserMaterialDialogHeaderTags
                material={material}
                nodes={nodes}
                isTeacherAlike={identity.isTeacherAlike}
              />
            ),
          }}
        />
      );
    }
  }

  return {
    openLinkUserMaterial,
  };
}
